import ScrollTrigger from 'gsap/ScrollTrigger';

const SELECTORS = {
  sectionInner: '.solucoes-formulario__inner',
  content: '.solucoes-formulario__content',
};

export function initSolucoesFormularioPin() {
  const inner = document.querySelector(SELECTORS.sectionInner);
  const content = inner?.querySelector(SELECTORS.content);
  const shouldPin = window.matchMedia('(min-width: 1025px)').matches;

  if (!inner || !content || !shouldPin) {
    return;
  }

  ScrollTrigger.create({
    trigger: inner,
    start: 'top top',
    end: () => `bottom top+=${content.offsetHeight}`,
    pin: content,
    pinSpacing: false,
    invalidateOnRefresh: true,
  });
}
